/* eslint no-unused-vars: "off" */
export function debounce(func: (...args: unknown[]) => void, timeout: number = 300): (...args: unknown[]) => void {
  let timer: ReturnType<typeof setTimeout> | undefined;
  return (...args: unknown[]) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func(...args); }, timeout);
  };
}